import { render, staticRenderFns } from "./flex-modal.vue?vue&type=template&id=3a2df7c4&scoped=true&lang=pug&"
import script from "./flex-modal.vue?vue&type=script&lang=js&"
export * from "./flex-modal.vue?vue&type=script&lang=js&"
import style0 from "./flex-modal.vue?vue&type=style&index=0&id=3a2df7c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2df7c4",
  null
  
)

export default component.exports